import * as allIcons from '@tabler/icons-react'

export default function Icon({name, style, stroke = 2, size}){
    const IconName = allIcons[name];
    return <IconName style={style} stroke={stroke} size={size}/>
}